import React from "react";
import FooterSection from "../../../components/sections/FooterSection";
import { useTranslation } from "react-i18next";

function VisaTravelOverviewPage(props) {
    var translationHook = useTranslation();
    var t = translationHook.t;

    return (
        <>
            {/* Hero Section */}
            <div
                className="uk-section uk-section-primary uk-light uk-flex uk-flex-middle uk-height-viewport"
                style={{
                    backgroundImage: "url('/imgvideo/pano1.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "brightness(0.65)"
                }}
            >
                <div className="uk-container uk-text-center">
                    <h1 className="uk-heading-medium uk-margin-remove-bottom">
                        Discover Kazakhstan
                    </h1>
                    <p className="uk-text-lead uk-margin-small-top">
                        Reliable visa assistance and full travel coordination with Jai International.
                    </p>
                </div>
            </div>

            {/* Introduction Section */}
            <div className="uk-section uk-section-default">
                <div className="uk-container uk-container-large">
                    <div className="uk-grid-large" uk-grid="true">
                        <div className="uk-width-2-3@m">
                            <h2 className="uk-heading-line">
                                <span>Experience Kazakhstan with Confidence</span>
                            </h2>
                            <p>
                                Jai International provides complete visa and travel assistance for visitors to Kazakhstan.
                                Our services are specifically designed for travellers from West Africa who seek cultural exploration,
                                leisure, or professional engagement in one of Central Asia’s most distinctive destinations.
                            </p>
                            <p>
                                Every stage of the process — from document submission to arrival logistics — is supported by our
                                experienced multilingual team with established partnerships throughout Kazakhstan.
                            </p>
                            <p>
                                Kazakhstan offers an exceptional blend of modern comfort and ancient heritage. From the
                                futuristic architecture of Astana to the vibrant energy of Almaty, travellers encounter
                                a country that harmoniously bridges Europe and Asia. Visitors can experience a dynamic
                                economy, rapidly developing industries, and opportunities for professional networking in
                                an emerging regional hub.
                            </p>
                            <p>
                                For those drawn to nature and culture, Kazakhstan’s vast landscapes provide unmatched
                                variety — snow-capped peaks, desert canyons, and the legendary steppe. Traditional music,
                                nomadic hospitality, and local cuisine reveal a living history that continues to shape the
                                national identity. Every journey becomes both a discovery and a connection to something
                                profoundly authentic.
                            </p>
                            <p>
                                Through Jai International, visitors gain access not only to reliable visa processing and
                                travel coordination but also to curated experiences that highlight the very best of
                                Kazakhstan’s people, culture, and innovation. The result is a seamless and memorable
                                exploration of a country where tradition meets opportunity.
                            </p>

                        </div>
                        <div className="uk-width-1-3@m uk-text-center">
                            <div className="uk-card uk-card-secondary uk-card-body uk-light uk-border-rounded">
                                <h3 className="uk-card-title uk-margin-remove">Tourist Visa Overview</h3>
                                <ul className="uk-list uk-list-striped uk-margin-small-top uk-text-left">
                                    <li>Visa type: B12 Tourist Visa</li>
                                    <li>Visa cost: $700 total</li>
                                    <li>Initial payment: $300 (pre-processing stage)</li>
                                    <li>Balance due after approval</li>
                                    <li>Ticket booking at traveller’s discretion</li>
                                    <li>Required: Passport copy, residence address, and country of residence</li>
                                </ul>
                                <p className="uk-text-meta uk-margin-small-top">
                                    Transparent pricing and staged payments ensure safety and accountability for all clients.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Destinations Section */}
            <div className="uk-section uk-section-muted">
                <div className="uk-container">
                    <h2 className="uk-text-center">Explore These Premier Destinations</h2>

                    <div className="uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-match" uk-grid="true">

                        <div>
                            <a href="/cities/astana" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Astana</h3>
                                    <p>
                                        Kazakhstan’s modern capital where innovation and design converge.
                                        Features iconic architecture, embassies, business districts, and
                                        vibrant cultural life surrounded by the endless steppe.
                                    </p>
                                </div>
                            </a>
                        </div>

                        <div>
                            <a href="/cities/almaty" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Almaty</h3>
                                    <p>
                                        The country’s former capital and cultural heart. Nestled at the
                                        foot of the Tien Shan mountains, Almaty blends urban sophistication
                                        with easy access to ski resorts, art galleries, and dynamic nightlife.
                                    </p>
                                </div>
                            </a>
                        </div>

                        <div>
                            <a href="/cities/aktau" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Aktau</h3>
                                    <p>
                                        Port city on the Caspian Sea famous for coastal resorts,
                                        beaches, and maritime atmosphere. Ideal for relaxation,
                                        sea views, and exploring western Kazakhstan.
                                    </p>
                                </div>
                            </a>
                        </div>

                        <div>
                            <a href="/cities/turkistan" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Turkistan</h3>
                                    <p>
                                        Ancient Silk Road city and spiritual center of the Turkic world.
                                        Home to the UNESCO-listed Mausoleum of Khoja Ahmed Yasawi and
                                        new modern developments that celebrate its heritage.
                                    </p>
                                </div>
                            </a>
                        </div>

                        <div>
                            <a href="/cities/shymkent" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Shymkent</h3>
                                    <p>
                                        Southern metropolis known for hospitality, cuisine, and colorful bazaars.
                                        Combines urban energy with proximity to natural and historical attractions
                                        across the Turkistan region.
                                    </p>
                                </div>
                            </a>
                        </div>

                        <div>
                            <a href="/sights/burabai" className="uk-link-reset">
                                <div className="uk-card uk-card-default uk-card-body uk-transition-toggle">
                                    <h3 className="uk-card-title">Borovoye</h3>
                                    <p>
                                        Often called the "Kazakh Switzerland" — a scenic retreat of lakes,
                                        pine forests, and granite peaks. Perfect for eco-tourism, hiking,
                                        and weekend getaways.
                                    </p>
                                </div>
                            </a>
                        </div>

                    </div>
                </div>
            </div>


            {/* Why Choose Jai Section */}
            <div className="uk-section uk-section-primary uk-light">
                <div className="uk-container">
                    <h2 className="uk-text-center">Why Choose Jai International</h2>

                    <div className="uk-grid-large uk-child-width-1-2@m" uk-grid="true">
                        <div>
                            <ul className="uk-list uk-list-large">
                                <li>Complete visa processing for West African passport holders</li>
                                <li>Personalised travel planning and destination advice</li>
                                <li>Assistance with flights, accommodation, and tours</li>
                                <li>Transparent pricing and secure staged payments</li>
                                <li>Multilingual support team based in Kazakhstan</li>
                            </ul>
                        </div>
                        <div>
                            <div className="uk-card uk-card-secondary uk-card-body uk-border-rounded">
                                <p>
                                    Every client receives direct communication with our visa coordination team.
                                    The process begins upon submission of passport details and residence information,
                                    ensuring complete clarity and compliance before payment completion.
                                </p>
                                <button
                                    className="uk-button uk-button-default uk-width-expand"
                                    onClick={function () {
                                        window.location.href = "/apply-visa";
                                    }}
                                >
                                    {t("ui.button.business_action.msg")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Service Stages Section */}
            <div className="uk-section uk-section-default">
                <div className="uk-container">
                    <h3 className="uk-text-center">{t("infopages.services.travel.kz-visa")}</h3>
                    <p className="uk-text-center uk-text-lead uk-margin-medium-bottom">
                        {t("infopages.services.travel.stages")}
                    </p>

                    <div className="uk-grid-match uk-child-width-1-3@m uk-child-width-1-2@s" uk-grid="true">
                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                <div className="uk-card-badge uk-label uk-label-success">Stage 1</div>
                                <h4 className="uk-margin-small-top uk-text-bold">Initial Submission</h4>
                                <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                    Submission of passport copy, residence address, and country of residence details. Initial pre-processing payment of $300 begins the visa preparation and documentation stage.
                                </p>
                            </div>
                        </div>

                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                <div className="uk-card-badge uk-label uk-label-warning">Stage 2</div>
                                <h4 className="uk-margin-small-top uk-text-bold">Processing & Approval</h4>
                                <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                    Official handling of the B12 Tourist Visa request, review of documents, and coordination with issuing authorities. Upon successful approval, balance payment of $400 is made to finalise visa issuance.
                                </p>
                            </div>
                        </div>

                        <div>
                            <div className="uk-card uk-card-default uk-card-body uk-border-rounded uk-text-center">
                                <div className="uk-card-badge uk-label uk-label-danger">Stage 3</div>
                                <h4 className="uk-margin-small-top uk-text-bold">Finalisation & Delivery</h4>
                                <p className="uk-text-small uk-text-muted uk-margin-small-top">
                                    Delivery of the approved visa and guidance for next steps. Traveller arranges flight booking independently according to personal schedule and budget.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <FooterSection />
        </>
    );
}

export default VisaTravelOverviewPage;
